import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { reduxForm, SubmissionError, submit } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router';

import RaisedButton from 'material-ui/RaisedButton';
import KeyboardArrowLeftIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import DoneIcon from 'material-ui/svg-icons/action/done';
import TextField from 'material-ui/TextField';

import { execute } from 'store/configureStore';
import * as sagaPorts from 'sagas/regions/ports';

import Sidebar from './Sidebar';
import ErrorBoundary from './ErrorBoundary';
import ServiceProviders from './ServiceProviders/Component';
import PortRestrictions from './PortRestrictions';
import LiftAndCranes from './LiftAndCranes/List';
import Facilities from './Facilities';
import Warehouses from './Warehouses';
import Other from './Other';
import MapComponent from 'components/Regions/PortAdd/MapComponent';

import { getPort, updatePort, clearPort, changePort } from 'actions/regions/ports';
import { getCountries } from 'actions/countries';

import { formName } from 'data/formNames';

import constants from 'constants';

const styles = {
    btnBack: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' },
    },
    btnSubmit: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' },
    },
};

class PortSinglePage extends React.Component {
    componentWillUnmount() {
        this.props.clearPort();
    }

    UNSAFE_componentWillMount() {
        const { routeParams: { id }, getPort, getCountries } = this.props;
        getPort({ id, history: true, all: true });
        getCountries();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.port.firstLoad && nextProps.port.history && nextProps.port.history.length > 0) {
            nextProps.clearPort();
            nextProps.router.push(`/regions/ports/approve/${nextProps.routeParams.id}`);
        }
    }

    shouldDiaplayCoordsError = (coord, leftLimit = -180, rightLimit = 180) => {
        let result = false;
        const value = parseFloat(coord);

        if (isNaN(value)) {
            result = true;
            return result;
        }

        if (value < leftLimit || value > rightLimit) {
            result = true;
        }

        return result;
    }

    render() {
        return (
            <div className='container' id='single-port'>
                <div className="management">
                    <div className="btn">
                        <RaisedButton
                            label="Back to list"
                            style={styles.btnBack.style}
                            labelStyle={styles.btnBack.labelStyle}
                            labelPosition="before"
                            icon={<KeyboardArrowLeftIcon />}
                            containerElement={<Link to='/regions/ports' />}
                            primary
                        />
                    </div>
                    <div className="btn">
                        <RaisedButton
                            label="Send modification"
                            style={styles.btnSubmit.style}
                            labelStyle={styles.btnSubmit.labelStyle}
                            labelPosition="before"
                            icon={<DoneIcon />}
                            backgroundColor="#a4c639"
                            onClick={() => this.props.submit('port-update')}
                        />
                    </div>
                </div>
                <div className="row">
                    <ErrorBoundary>
                        <Sidebar />
                    </ErrorBoundary>
                    <div className="col-lg-9 col-xs-9 main">
                        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
                            <ErrorBoundary>
                                <div className='add-coords-map'>
                                    <div className='main__title'>Coordinates</div>
                                    <MapComponent
                                        coordinates={this.props.port.coordinates}
                                        change={(key, value) => {
                                            this.props.changePort({ coordinates: value });
                                        }}
                                        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                        loadingElement={<div style={{ height: '100%' }} />}
                                        containerElement={<div style={{ width: '100%', height: '300px' }} />}
                                        mapElement={<div style={{ height: '100%' }} />}
                                    />
                                    <TextField
                                        floatingLabelText='Latitude'
                                        value={this.props.port.coordinates[1]}
                                        onChange={(e, value) => {
                                            const lat = value.replace(/[a-zA-Z,]/g, '');
                                            this.props.changePort({ coordinates: [this.props.port.coordinates[0], parseFloat(lat)] });
                                        }}
                                        errorText={this.shouldDiaplayCoordsError(this.props.port.coordinates[0], -180, 180) ? 'wrong format' : ''}
                                        fullWidth
                                    />
                                    <TextField
                                        floatingLabelText='Longitude'
                                        value={this.props.port.coordinates[0]}
                                        onChange={(e, value) => {
                                            const lon = value.replace(/[a-zA-Z,]/g, '');
                                            this.props.changePort({ coordinates: [parseFloat(lon), this.props.port.coordinates[1]] });
                                        }}
                                        errorText={this.shouldDiaplayCoordsError(this.props.port.coordinates[1], -90, 90) ? 'wrong format' : ''}
                                        fullWidth
                                    />
                                </div>
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <ServiceProviders
                                    parentProps={this.props}
                                />
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <PortRestrictions />
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <LiftAndCranes
                                    parentProps={this.props}
                                />
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <Facilities />
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <Warehouses />
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <Other />
                            </ErrorBoundary>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

PortSinglePage.propTypes = {

};

PortSinglePage.defaultProps = {

};

const handleSubmit = async (values, dispatch) => {
    const data = _.cloneDeep(values);
    data.serviceProviders.map((provider) => {
        if (!provider.activities.includes('Stevedoring Company')) {
            provider.limitations = [];
        }
    });

    Object.keys(data.portLimitations).forEach((key) => {
        if (!data.portLimitations[key]) {
            delete data.portLimitations[key];
        }
    });

    const response = await execute(sagaPorts.updatePort, data);

    if (response.status !== 200) {
        let errors = {};

        response.errors.forEach((error) => {
            errors = _.merge(errors, _.set({}, error.field, error.messages[0]));
        });

        throw new SubmissionError(errors);
    }
};

const MainPage = reduxForm({
    form: formName.portUpdate,
    enableReinitialize: true,
    onSubmit: handleSubmit,
})(PortSinglePage);

export default connect(
    ({ port, user: { isLogged } }) => ({
        isLogged,
        initialValues: { ...port },
        port,
    }),
    dispatch => bindActionCreators({
        getPort,
        submit,
        getCountries,
        updatePort,
        clearPort,
        changePort,
    }, dispatch),
)(MainPage);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/Page.jsx